// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2-dhR","actionsCol":"EnrolledClinics_actionsCol__1I0jL"};